import React, { Component } from "react";
import {LOGIN_TYPE_ADMIN} from "./helper/Constants";
import Apihelpers from "./helper/ApiHelper";
// import { consoleTestResultHandler } from "tslint/lib/test";
import {Alert } from 'rsuite';
import $ from "jquery";
import { reactLocalStorage } from 'reactjs-localstorage';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { NavLink } from "react-router-dom";

import Header from "./include/Header";
import PlanList from "./clientView/PlanList"
import ClientProfileUpdate from "./clientView/ClientProfileUpdate"
import ClientConfUpdate from "./clientView/ClientConfUpdate"

// import Select2 from 'react-select2-wrapper';
// import 'react-select2-wrapper/css/select2.css';


class CreateClientEditView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //currentRenderTab: 1,
      //isDetailFound: null,
      userData: [],
      bbUserData: [],
      // bbuserPaymentHistoryData: [],
      // bbuserApiHitHistoryData: [],
      bbActivePlan: {},
      bbActiveService: [],
      //bbactivePlanPayment: [],
      masterServices: [],
      activeToken: "",
      //usesApiHitHistoryJsonParse: [],
      // updateMobileNumber: "",
      // updateAddress: "",
      // //: "",
      // isUpdate: null,
      // isLoad: false,
      // paymentAmount: "",
      // bulkRcfile: "",
      // bulkRcEnginefile: "",
      // invoiceNumber: "",
      // remark: "",
      // invoiceImage: "",
      // hasbulkRcfileError: true,
      // hasbulkRcEnginefileError: true,
      // haspaymentAmountError: true,
      // hasinvoiceImageError: true,
      // hasinvoiceNumberError: true,
      // hasRemarkError: true,
      // hasupdateNumberError: false,
      // hasUpdateAddressError: false,
      // hasplanPeriodsError: "null",
      // hasInvoiceExistError: false,
      // planStartdate: "",
      // planEnddate: "",
      copied: false,
      // isupdating: false,
      //serviceList: [],
      //SelectedListArray: [],
      // clientPlanList: [],
      // clientPlanListJson: "",
      // rcexcelDownloadData: [],
      // ip_address_allowed: "",
      // per_day_limit: "",

      profileUpdatePopup: false,
      confUpdatePopup: false
    };
    this.hideUpdateModel = this.hideUpdateModel.bind(this);
    this.hideConfUpdateModel = this.hideConfUpdateModel.bind(this);
  }

  componentDidMount() {
    let bbuserid = this.props.match.params.someid;
    this.loadClientEditDetail(bbuserid);
    // this.loadRcexcelDownloadData(bbuserid);

    /*$("#ModifyServicePopUp").on("select2:select", function (evt) {
      var element = evt.params.data.element;
      console.log('element',element);
      var $element = $(element);
      let id = evt.target.id;
      console.log('id',id)
      $element.detach();
      $('#'+id).append($element);
      $('#'+id).trigger("change");
    });*/
  }



  loadClientEditDetail(bbuserid) {
    $('.loader').css('display', 'block');
    Apihelpers.postdataresponse('bbuser/bbuser_getdetail/' + bbuserid).then(res => {
      //console.log('res.data.data............',res.data.data);
      if (res.data.status === true) {
        var parserActivePlan = JSON.parse(res.data.data.getData.active_plan);
        let bbuserInfo = res.data.data.getData;
        //console.log('bbuserInfo',bbuserInfo);
        let ips = [];
        if (bbuserInfo.allowed_ip_addresses?.length > 0) {
          ips = bbuserInfo.allowed_ip_addresses.split(",");
        }
        this.setState({
          userData: {...res.data.data.userdata, 'business_unit': bbuserInfo.business_unit},
          bbUserData: bbuserInfo,
          bbActivePlan: parserActivePlan,
          bbActiveService: parserActivePlan.service,
          masterServices: res.data.data.mtServices,
          activeToken: bbuserInfo.token,
          isSelectListValidate: parserActivePlan.service.length
        });
      } else {
        this.setState({
          userData: {},
          bbUserData: {},
          bbActivePlan: {},
          bbActiveService: [],
        });
      }
      $('.loader').css('display', 'none');
    }).catch(function (error) {
      console.log('error.......',error);
      Alert.error("Something is wrong...")
      $('.loader').css('display', 'none');
    });
  }

  hideUpdateModel = () => {
    this.setState({
      profileUpdatePopup: false
    })
  }
  hideConfUpdateModel = () => {
    this.setState({
      confUpdatePopup: false
    })
  }
  removedCopied = () => {
    this.setState({
      copied: false
    })
  }


  render() {
    return (
      <React.Fragment>
        <div className="wrapper">
          <Header />
          <div className="container">
              <div className="clientEditPage">
              {
                //JSON.stringify(this.state.bbUserData,null,2)
              }
                <div className="titleRow">
                  <div className="row no-gutters">
                    <div className="col">
                      <h3 className="title">
                        {
                          reactLocalStorage.get("login_type") !== LOGIN_TYPE_ADMIN ? 'My Profile' : 'Client Profile'
                        }
                      </h3>
                    </div>
                    {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ?
                      <div className="col-auto">
                        <NavLink className="backLink" to={"/admin/client-list"} exact  ><i className="fa fa-arrow-left"></i> Back</NavLink>
                      </div>
                      : null}
                  </div>
                </div>
                <div>
                  <div>
                    <div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="clientProInfo">
                            <div className="textA">
                              <h4>{this.state.bbUserData.business_name}
                                {reactLocalStorage.get("login_type") == LOGIN_TYPE_ADMIN ?
                                  <>
                                    <span className="btn-icon" onClick={() => {
                                      this.setState({
                                        profileUpdatePopup: true
                                      })
                                    }}><i className="fa fa-edit"></i></span>
                                    <span className="btn-icon" onClick={()=>{
                                      this.setState({confUpdatePopup:true})
                                    }}>
                                      <i className="fa fa-cog"></i>
                                    </span>
                                  </> 
                                  :""
                                  }
                              </h4>
                              {/* <div className="desc">{this.state.bbActivePlan.plan_type} Plan</div> */}
                            </div>
                            <div className="textB">
                              <div className="row">
                                <div className="col-md-4">
                                  <p className="call"><a href={'tel:' + this.state.userData.contact_number}>{this.state.userData.contact_number}</a></p>
                                </div>
                                <div className="col-md-8">
                                  <p className="email"><a href={'mailto:' + this.state.userData.email}>{this.state.userData.email}</a></p>
                                </div>
                                <div className="col-md-12">
                                  <p className="address">{this.state.userData.address}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="profileBlockC form">
                            <div className="form-group authentication">
                              <CopyToClipboard text={this.state.activeToken}
                                onCopy={() => this.setState({ copied: true })}>
                                <label className="control-title">authentication token <span className="copyLink">copy</span></label>
                              </CopyToClipboard>
                              {this.state.copied ? <div className="copytoclipbox"><span style={{ fontSize: 11 }}>Successfully Copied</span> &nbsp; <span onClick={this.removedCopied} style={{ cursor: "pointer", fontSize: 11 }}>X</span></div> : <span></span>}
                              <textarea readOnly={true} className="form-control" defaultValue={this.state.activeToken} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          {
                            (this.state.masterServices.length > 0) ?
                              <PlanList list={this.state.bbActiveService} bbUser={this.state.bbUserData} masterServices={this.state.masterServices} />
                            :""
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="loader" style={{ display: "none", zIndex:101 }}>
                <div className="bg"></div>
                <img className="loadingImg" src="/assets/images/loading.gif" alt="" />
              </div>
          </div>

          {
            this.state.profileUpdatePopup ? 
            <ClientProfileUpdate userData={this.state.userData} hideUpdateModel={this.hideUpdateModel} />
            : ""
          }
          {
            this.state.confUpdatePopup ? 
            <ClientConfUpdate bbUserData={this.state.bbUserData} hideUpdateModel={this.hideConfUpdateModel} />
            : ""
          }

        </div>
      </React.Fragment>
    )
  }
}

export default CreateClientEditView;
